module.exports = __webpack_public_path__ + "img/ic-breadcrumb-arrow.b49f941b.svg";